import { render } from "./ExerciseCard.vue?vue&type=template&id=085741bc&scoped=true"
import script from "./ExerciseCard.vue?vue&type=script&lang=js"
export * from "./ExerciseCard.vue?vue&type=script&lang=js"

import "./ExerciseCard.vue?vue&type=style&index=0&id=085741bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085741bc"]])

export default __exports__